import { render, staticRenderFns } from "./t-page-title.vue?vue&type=template&id=2074e577&"
import script from "./t-page-title.vue?vue&type=script&lang=js&"
export * from "./t-page-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports